import styles from "./theming-sub-tab-container.less";

type ThemingSubTabContainerProps = {
    children: React.ReactNode | Array<React.ReactNode>;
};

export const ThemingSubTabContainer = (props: ThemingSubTabContainerProps) => {
    const { children } = props;

    return (
        <div className={styles.themingSubTabContainer}>
            {children}
        </div>
    );
};